import React from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button
} from "reactstrap";

const DisputeClaimDetail = () => {
  return (
    <div className="page-content bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card className="shadow border-0 rounded-3">
              <CardBody className="p-5">
                <h4 className="text-center text-primary mb-4">
                  Dispute Claim Details
                </h4>

                {/* --- Claim Summary --- */}
                <Row className="mb-4">
                  <Col md={6}>
                    <p className="text-muted mb-1 small">Claim Reference ID</p>
                    <h6 className="fw-semibold">DC-2025-48231</h6>
                  </Col>
                  <Col md={6}>
                    <p className="text-muted mb-1 small">Date of Transaction</p>
                    <h6 className="fw-semibold">06 Nov 2025</h6>
                  </Col>
                  <Col md={6}>
                    <p className="text-muted mb-1 small">Transaction Amount</p>
                    <h6 className="fw-semibold">NPR 12,500.00</h6>
                  </Col>
                  <Col md={6}>
                    <p className="text-muted mb-1 small">Card / Account</p>
                    <h6 className="fw-semibold">XXXX-5643</h6>
                  </Col>
                </Row>

                {/* --- Status Badge --- */}
                <div className="text-center mb-4">
                  <Badge color="warning" pill className="px-3 py-2">
                    Under Investigation
                  </Badge>
                </div>

                {/* --- Timeline --- */}
                <div className="position-relative border-start border-3 border-primary ps-4 mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center mb-1">
                      <div className="bg-primary rounded-circle me-3" style={{ width: 10, height: 10 }}></div>
                      <h6 className="fw-semibold mb-0">Claim Submitted</h6>
                    </div>
                    <small className="text-muted ms-4">06 Nov 2025, 10:24 AM</small>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex align-items-center mb-1">
                      <div className="bg-primary rounded-circle me-3" style={{ width: 10, height: 10 }}></div>
                      <h6 className="fw-semibold mb-0">Claim Verified</h6>
                    </div>
                    <small className="text-muted ms-4">07 Nov 2025, 03:45 PM</small>
                  </div>

                  <div>
                    <div className="d-flex align-items-center mb-1">
                      <div className="bg-secondary rounded-circle me-3" style={{ width: 10, height: 10 }}></div>
                      <h6 className="fw-semibold mb-0 text-secondary">
                        Awaiting Merchant Response
                      </h6>
                    </div>
                  </div>
                </div>

                {/* --- Footer --- */}
                <div className="text-center">
                  <p className="text-muted small mb-3">
                    Your claim is being reviewed. Estimated resolution time:{" "}
                    <span className="fw-semibold">3–5 working days</span>.
                  </p>
                  <Link to="/dispute-claim">
                  <Button color="primary" className="px-4">
                    Back to Home
                  </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DisputeClaimDetail;
